import React from 'react'
import "./previous.css"
import prev1 from "../images/prev1.jpg"
import prev2 from "../images/prev2.jpeg"
import prev3 from "../images/prev3.jpeg"
import prev4 from "../images/prev4.jpeg"
import prev5 from "../images/prev5.jpeg"
import prev6 from "../images/prev6.jpeg"
import prev7 from "../images/prev7.jpeg"
import prev8 from "../images/prev8.jpeg"
import prev9 from "../images/prev9.jpeg"
import prev10 from "../images/prev10.jpeg"
import prev11 from "../images/prev11.jpeg"
import prev12 from "../images/prev12.jpeg"
import prev13 from "../images/prev13.jpeg"
import prev14 from "../images/prev14.jpeg"
import prev15 from "../images/prev15.jpeg"
import prev16 from "../images/prev16.jpeg"
import prev17 from "../images/prev17.jpeg"
import prev18 from "../images/prev18.jpeg"
import prev19 from "../images/prev19.jpeg"
import prev20 from "../images/prev20.jpeg"
import prev21 from "../images/prev21.jpeg"
import prev22 from "../images/prev22.jpeg"
import prev23 from "../images/prev23.jpeg"
import prev24 from "../images/prev24.jpeg"
import prev25 from "../images/prev25.jpeg"
import prev26 from "../images/prev26.jpeg"
import prev27 from "../images/prev27.jpeg"
import prev28 from "../images/prev28.jpeg"
import prev29 from "../images/prev29.jpeg"
import prev30 from "../images/prev30.jpeg"
import prev31 from "../images/prev31.jpeg"
import prev32 from "../images/prev32.jpeg"
import prev33 from "../images/prev33.jpeg"
import prev34 from "../images/prev34.jpeg"
/* test */
const PreviousEvents = () => {
  return (
    <>
    <section className='previous-section'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-12 mb-3'>
                    <h1 className="joining-heading text-center">
                        Have A Glimpse On <br /> Previous Years
                    </h1>
                </div>
                <div className='col-lg-12 mt-5'>
                    <div className='fade'></div>
                    <div className='middle'>
                        <div className='gallery'>
                            <img src={prev1} alt='Previous Years Images'/>
                            <img src={prev2} alt='Previous Years Images' />
                            <img src={prev3} alt='Previous Years Images' />
                            <img src={prev4} alt='Previous Years Images' />
                            <img src={prev5} alt='Previous Years Images' />
                            <img src={prev6} alt='Previous Years Images' />
                            <img src={prev7} alt='Previous Years Images' />
                            <img src={prev8} alt='Previous Years Images' />
                            <img src={prev9} alt='Previous Years Images' />
                            <img src={prev10} alt='Previous Years Images'/>
                            <img src={prev11} alt='Previous Years Images'/>
                            <img src={prev12} alt='Previous Years Images'/>
                            <img src={prev13} alt='Previous Years Images'/>
                            <img src={prev14} alt='Previous Years Images'/>
                            <img src={prev15} alt='Previous Years Images'/>
                            <img src={prev16} alt='Previous Years Images'/>
                            <img src={prev17} alt='Previous Years Images'/>
                            <img src={prev18} alt='Previous Years Images'/>
                            <img src={prev19} alt='Previous Years Images'/>
                            <img src={prev20} alt='Previous Years Images'/>
                            <img src={prev21} alt='Previous Years Images'/>
                            <img src={prev22} alt='Previous Years Images'/>
                            <img src={prev23} alt='Previous Years Images'/>
                            <img src={prev24} alt='Previous Years Images'/>
                            <img src={prev25} alt='Previous Years Images'/>
                            <img src={prev26} alt='Previous Years Images'/>
                            <img src={prev27} alt='Previous Years Images'/>
                            <img src={prev28} alt='Previous Years Images'/>
                            <img src={prev29} alt='Previous Years Images'/>
                            <img src={prev30} alt='Previous Years Images'/>
                            <img src={prev31} alt='Previous Years Images'/>
                            <img src={prev32} alt='Previous Years Images'/>
                            <img src={prev33} alt='Previous Years Images'/>
                            <img src={prev34} alt='Previous Years Images'/>
                        </div>
                    </div>
                    <div className='fade2'></div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}

export default PreviousEvents